/*
 * @Description: Type your file description
 * @Author: qiangwu
 * @LastEditors: qiangwu
 * @Date: 2020-11-20 14:39:19
 * @LastEditTime: 2020-11-30 10:05:44
 * @FilePath: \ensurance-front\src\store\getters.js
 */
/*
 * @Description: Type your file description
 * @Author: qiangwu
 * @LastEditors: qiangwu
 * @Date: 2020-11-20 14:32:30
 * @LastEditTime: 2020-11-20 14:32:38
 * @FilePath: \toutjiao-moblie\src\store\getter.js
 */
const getters = {
  // sidebar: (state) => state.app.sidebar,
  // size: (state) => state.app.size,
  // device: (state) => state.app.device,
  // visitedViews: (state) => state.tagsView.visitedViews,
  // cachedViews: (state) => state.tagsView.cachedViews,
  token: state => state.user.token,
  refreshToken: state => state.user.refreshToken,
  routerPath: state => state.router.routerPath,
  tableInfo: state => state.tables.tableInfo,
  userInfo: state => state.user.userInfo,
  userRoles: state => state.user.roles,
  tabList: state => state.tabs.tabList
  // introduction: (state) => state.user.introduction,
  // roles: (state) => state.user.roles,
  // editStatus: (state) => state.user.editStatus,
  // routeList: (state) => state.user.routeList,
  // selectValue: (state) => state.user.selectValue,
  // changeValue: (state) => state.user.changeValue,
  // formValue: (state) => state.user.formValue,
  // departmentValue: (state) => state.user.departmentValue,
  // pageData: (state) => state.user.pageData,
  // addPhoto: (state) => state.user.addPhoto,
  // attendanceDate: (state) => state.user.attendanceDate,
  // permission_routes: (state) => state.permission.routes,
  // errorLogs: (state) => state.errorLog.logs
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js